export default __webpack_public_path__ + "static/media/48.c0598e82.png";